var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promotedResource && !_vm.loading)?_c('div',[_c('Resource',{attrs:{"title":_vm.title,"img":_vm.img,"link":_vm.link,"inSameWindow":_vm.inSameWindow,"header":_vm.headerTitle}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }